'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { NetworkAvatar } from '@morpho-org/ui-v6/client';
import type { OptionSelectMultipleNetwork } from '../SelectMultipleNetwork';
export default function ButtonContent(t0) {
  const $ = _c(13);
  const {
    values,
    options
  } = t0;
  let selectedOptions;
  let t1;
  if ($[0] !== options || $[1] !== values) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t2;
      if ($[4] !== options) {
        t2 = value => options.find(option => option.value === value);
        $[4] = options;
        $[5] = t2;
      } else {
        t2 = $[5];
      }
      selectedOptions = values.map(t2);
      if (selectedOptions.length > 1) {
        t1 = <><NetworkAvatar chainId={selectedOptions[0]?.value} />{selectedOptions.slice(1).map(_temp)}</>;
        break bb0;
      }
    }
    $[0] = options;
    $[1] = values;
    $[2] = selectedOptions;
    $[3] = t1;
  } else {
    selectedOptions = $[2];
    t1 = $[3];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  const t2 = selectedOptions[0]?.value;
  let t3;
  if ($[6] !== t2) {
    t3 = <NetworkAvatar chainId={t2} />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = selectedOptions[0]?.label;
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-2xs">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="gap-xs flex items-center">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp(option_0) {
  return <NetworkAvatar chainId={option_0?.value} key={String(option_0?.value)} srcAvatarProps={{
    className: "-ml-xs"
  }} />;
}